let React =              require("react");

var ApplicationContext = require("../../config/ApplicationContext.js");
var EditorLaunchUtil = require("../../util/EditorLaunchUtil.js");

class Menu extends React.Component {

    constructor(){
        super();

        this.state = { selected: "infoPublic"};
        this.onChangeView = this.onChangeView.bind(this);
        this.onChangeList = this.onChangeList.bind(this);
    }

    onChangeView(selected){
        this.setState({ selected });
        this.props.onChangeView( selected );
    }

    onChangeList(){
        this.props.onChangeList();
        this.icon.classList.toggle("grid");
    }

    newPackage(){
        let win = window.open(EditorLaunchUtil.editorUrl(ApplicationContext.getPackageEditor(), {}), '_blank');
        if (win) { win.focus() }
    }

    render() {
        const { selected } = this.state;
        let classNamePublic = selected === "infoPublic" ? "menu__contOption__option active": "menu__contOption__option";
        let classNamePrivate = selected === "infoPrivate" ? "menu__contOption__option active": "menu__contOption__option";
        
        return (
            <div className="menu">
                <div className="spaceBetween">
                    <div className="menu__contOption spaceAround">
                        <div className={classNamePublic} onClick={() => this.onChangeView("infoPublic")}>Packages</div>
                        <div className={classNamePrivate} onClick={() => this.onChangeView("infoPrivate")}>My Packages</div>
                    </div>
                    <div className="menu__newPackages">
                        <button className="button" onClick={this.newPackage}>Create New Package</button>
                    </div>
                    <div className="menu__icon">
                        <div onClick={this.onChangeList} ref={f => this.icon = f}></div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = Menu;
